import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import API from "../API/API";
import { GetPage } from "../scripts";

export const OGMetaTagBase = [
  {
    tag: "og:title",
    from: "base",
    key: "title"
  },
  {
    tag: "og:description",
    from: "base",
    key: "description"
  },
  {
    tag: "og:image",
    useImgURL: true,
    from: "base",
    key: "image"
  },
  {
    tag: "og:type",
    from: "text",
    data: "website"
  }
];

/**
 *
 *
 * @class MetaTagComp
 * @extends {Component}
 */
class MetaTagComp extends Component {
  static propTypes = {
    /** Meta Tags used */
    metaTags: PropTypes.array,
    /** Meta Tags to replace or add besides metaTags
     * Format of replaceMetaTags:
     * {
     *      name: "string" //name of the tag (title, description, etc)
     *      content: "string" //content of the tag (Guaostudio | Inicio, Somos una empresa creativa, etc)
     *      useImgURL: "bool" //true or false if is an image
     *      isProperty: "bool" //true or false if is the tag use property insted of name
     * }
     */
    replaceMetaTags: PropTypes.array
  };

  constructor(props) {
    super(props);
    this.state = {
      MetaTags: []
    };
    this.checkMetaTags = false;
    this.replaceMetaTags = this.props.replaceMetaTags;
    this.verifyPages = this.verifyPages.bind(this);
    this.verifyMetaTags = this.verifyMetaTags.bind(this);
  }

  componentDidMount() {
    this.verifyPages(this.props.pages);
  }

  componentWillReceiveProps(nextProps) {
    this.replaceMetaTags = nextProps.replaceMetaTags;
    if (this.props.section !== nextProps.section) {
      this.verifyPages(nextProps.pages, true);
    } else {
      this.verifyPages(nextProps.pages);
    }
  }

  verifyPages(pages, forceCheck = false) {
    if (
      (pages !== undefined &&
        pages.length > 0 &&
        this.props.section !== "" &&
        this.state.MetaTags.length === 0 &&
        this.checkMetaTags === false) ||
      forceCheck === true
    ) {
      this.checkMetaTags = true;
      const currentPage = GetPage(pages, this.props.section);
      const api = new API();
      api.getContentOf(currentPage.id).then(response => {
        let currentMetTags = response[0].metaTags;
        this.verifyMetaTags(currentMetTags);
      });
    }
  }

  verifyMetaTags(metaTags) {
    //Check if we have metaTags or replaceMetaTags if no return and do nothing
    if (metaTags === undefined && this.replaceMetaTags === undefined) {
      return;
    }

    //Get current metatags
    let currentMetTags = [...metaTags];

    //If we have replaceMetaTags we replace or add the new meta tags
    if (this.replaceMetaTags !== undefined) {
      for (let i = 0; i < this.replaceMetaTags.length; i++) {
        const currentReplaceMT = this.replaceMetaTags[i];
        const findReplaceMT = currentMetTags.find(metaTagTemp => {
          return metaTagTemp.name === currentReplaceMT.name;
        });
        if (findReplaceMT === undefined) {
          let addMT = {
            name: currentReplaceMT.name,
            content: currentReplaceMT.content,
            useImgURL:
              currentReplaceMT.useImgURL !== undefined
                ? currentReplaceMT.useImgURL
                : false,
            isProperty:
              currentReplaceMT.isProperty !== undefined
                ? currentReplaceMT.isProperty
                : false
          };
          currentMetTags.push(addMT);
        } else {
          const indexOfFoundMT = currentMetTags.indexOf(findReplaceMT);
          currentMetTags[indexOfFoundMT].content = currentReplaceMT.content;
          currentMetTags[indexOfFoundMT].useImgURL =
            currentReplaceMT.useImgURL !== undefined
              ? currentReplaceMT.useImgURL
              : currentMetTags[indexOfFoundMT].useImgURL;
          currentMetTags[indexOfFoundMT].isProperty =
            currentReplaceMT.isProperty !== undefined
              ? currentReplaceMT.isProperty
              : currentMetTags[indexOfFoundMT].isProperty;
        }
      }
    }

    //If we have Open Graphs Meta Tags on MainInfo Data we added
    for (let i = 0; i < OGMetaTagBase.length; i++) {
      const currentOG = OGMetaTagBase[i];
      const findOGMT = currentMetTags.find(metaTagTemp => {
        return metaTagTemp.name === currentOG.tag;
      });
      if (findOGMT === undefined) {
        if (currentOG.from === "base") {
          const keyMT = currentMetTags.find(metaTagTemp => {
            return metaTagTemp.name === currentOG.key;
          });

          let addMTOG = {
            name: currentOG.tag,
            useImgURL:
              currentOG.useImgURL !== undefined ? currentOG.useImgURL : false,
            content: "",
            isProperty: true
          };
          if (keyMT !== undefined) {
            addMTOG.content = keyMT.content;
          }
          if (addMTOG.content !== "") {
            currentMetTags.push(addMTOG);
          }
        } else if (currentOG.from === "text") {
          let addMTOG = {
            name: currentOG.tag,
            useImgURL:
              currentOG.useImgURL !== undefined ? currentOG.useImgURL : false,
            content: currentOG.data,
            isProperty: true
          };
          if (addMTOG.content !== "") {
            currentMetTags.push(addMTOG);
          }
        }
      }
    }
    this.setState({ MetaTags: currentMetTags });
  }

  render() {
    console.log(this.props.section);
    return (
      <MetaTags>
        {this.state.MetaTags.map((tag, index) => {
          if (tag.name === "title") {
            return <title key={index}>{tag.content}</title>;
          } else if (tag.isProperty === true) {
            return (
              <meta key={index} property={tag.name} content={tag.content} />
            );
          } else {
            return <meta key={index} name={tag.name} content={tag.content} />;
          }
        })}

        <meta
          property="og:url"
          content={typeof window === "undefined" ? "" : window.location.href}
          className="next-head"
        />
      </MetaTags>
    );
  }
}

const mapStateToProps = ({ data }) => {
  const { pages } = data;
  return {
    pages
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    {}
  )(MetaTagComp)
);
